// extracted by mini-css-extract-plugin
export var animationContainer = "_h7-0";
export var asteriskIcon = "_h7-8";
export var conversationLeftSection = "_h7-4";
export var conversationListItem = "_h7-3";
export var conversationMiddleSection = "_h7-5";
export var conversationRightSection = "_h7-6";
export var detailsContent = "_h7-1";
export var listContainer = "_h7-7";
export var modalContent = "_h7-2";